import React from 'react'

const TermsPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Syarat dan Ketentuan</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>Terakhir diperbarui:</strong> {new Date().toLocaleDateString('id-ID')}
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Penerimaan Syarat</h2>
            <div className="bg-blue-50 p-6 rounded-lg">
              <p className="mb-4">
                Dengan mengakses dan menggunakan platform e-commerce Hilal Technologic 
                ("Layanan"), Anda menyetujui untuk terikat oleh syarat dan ketentuan ini.
              </p>
              <div className="bg-white p-4 rounded border-l-4 border-blue-400">
                <h3 className="font-medium mb-2">Definisi Penting:</h3>
                <ul className="list-disc pl-6 space-y-1 text-sm">
                  <li><strong>"Kami"</strong> mengacu pada Hilal Technologic</li>
                  <li><strong>"Anda"</strong> mengacu pada pengguna layanan</li>
                  <li><strong>"Platform"</strong> mengacu pada website dan API kami</li>
                  <li><strong>"Produk Digital"</strong> mengacu pada semua produk yang dijual</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Layanan yang Disediakan</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">🛒 E-Commerce Platform</h3>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                  <li>Penjualan produk digital</li>
                  <li>Sistem pembayaran terintegrasi</li>
                  <li>Manajemen akun pengguna</li>
                  <li>Riwayat pembelian</li>
                  <li>Download center</li>
                </ul>
              </div>
              
              <div className="bg-purple-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">🔐 Fitur Keamanan</h3>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                  <li>Two-Factor Authentication</li>
                  <li>Enkripsi data end-to-end</li>
                  <li>Audit logging</li>
                  <li>Rate limiting</li>
                  <li>Fraud detection</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Akun Pengguna</h2>
            <div className="bg-yellow-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">Persyaratan Akun:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Anda harus berusia minimal 18 tahun atau memiliki izin wali</li>
                <li>Informasi yang diberikan harus akurat dan terkini</li>
                <li>Satu orang hanya boleh memiliki satu akun</li>
                <li>Anda bertanggung jawab atas keamanan akun Anda</li>
              </ul>
              
              <div className="mt-4 p-4 bg-white rounded border">
                <h4 className="font-medium mb-2">🔒 Keamanan Akun:</h4>
                <ul className="list-disc pl-6 space-y-1 text-sm">
                  <li>Gunakan password yang kuat (min 8 karakter)</li>
                  <li>Aktifkan Two-Factor Authentication</li>
                  <li>Jangan bagikan kredensial login</li>
                  <li>Laporkan aktivitas mencurigakan segera</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Produk Digital</h2>
            <div className="space-y-6">
              <div className="bg-indigo-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">Jenis Produk:</h3>
                <div className="grid md:grid-cols-3 gap-4">
                  <div className="bg-white p-4 rounded">
                    <h4 className="font-medium">📚 E-books</h4>
                    <p className="text-sm text-gray-600">PDF, EPUB, MOBI</p>
                  </div>
                  <div className="bg-white p-4 rounded">
                    <h4 className="font-medium">💻 Software</h4>
                    <p className="text-sm text-gray-600">Aplikasi dan tools</p>
                  </div>
                  <div className="bg-white p-4 rounded">
                    <h4 className="font-medium">🎓 Courses</h4>
                    <p className="text-sm text-gray-600">Video pembelajaran</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-400">
                <h3 className="text-lg font-medium mb-3">⚠️ Lisensi dan Penggunaan:</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Produk hanya untuk penggunaan pribadi</li>
                  <li>Dilarang mendistribusikan atau menjual kembali</li>
                  <li>Tidak boleh melakukan reverse engineering</li>
                  <li>Hak cipta tetap milik pencipta asli</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Pembayaran dan Pengembalian</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">💳 Metode Pembayaran</h3>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                  <li>Kartu kredit/debit</li>
                  <li>Transfer bank</li>
                  <li>E-wallet (OVO, GoPay, DANA)</li>
                  <li>QRIS</li>
                </ul>
                <p className="mt-3 text-sm text-gray-600">
                  Pembayaran diproses melalui Midtrans dengan keamanan PCI DSS.
                </p>
              </div>
              
              <div className="bg-orange-50 p-6 rounded-lg">
                <h3 className="text-lg font-medium mb-3">🔄 Kebijakan Pengembalian</h3>
                <div className="space-y-3">
                  <div className="bg-white p-3 rounded">
                    <h4 className="font-medium text-sm">✅ Dapat Dikembalikan:</h4>
                    <ul className="list-disc pl-4 text-xs space-y-1">
                      <li>Produk rusak atau tidak dapat diakses</li>
                      <li>Kesalahan teknis dalam 24 jam</li>
                      <li>Duplikasi pembelian tidak sengaja</li>
                    </ul>
                  </div>
                  <div className="bg-white p-3 rounded">
                    <h4 className="font-medium text-sm">❌ Tidak Dapat Dikembalikan:</h4>
                    <ul className="list-disc pl-4 text-xs space-y-1">
                      <li>Produk sudah didownload dan berfungsi</li>
                      <li>Perubahan pikiran setelah pembelian</li>
                      <li>Ketidakcocokan dengan ekspektasi</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Perilaku Pengguna</h2>
            <div className="bg-red-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">🚫 Aktivitas yang Dilarang:</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <h4 className="font-medium mb-2">Keamanan:</h4>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Hacking atau cracking sistem</li>
                    <li>Menggunakan bot atau script otomatis</li>
                    <li>Mencoba mengakses akun orang lain</li>
                    <li>Menyebarkan malware atau virus</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-medium mb-2">Konten:</h4>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Membagikan konten ilegal</li>
                    <li>Melanggar hak cipta</li>
                    <li>Spam atau phishing</li>
                    <li>Konten yang menyinggung</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Keamanan dan Privasi</h2>
            <div className="bg-blue-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">🛡️ Komitmen Keamanan:</h3>
              <div className="space-y-4">
                <div className="bg-white p-4 rounded">
                  <h4 className="font-medium mb-2">Data Protection:</h4>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Enkripsi AES-256 untuk data sensitif</li>
                    <li>HTTPS untuk semua komunikasi</li>
                    <li>Regular security audits</li>
                    <li>GDPR compliance</li>
                  </ul>
                </div>
                <div className="bg-white p-4 rounded">
                  <h4 className="font-medium mb-2">Monitoring:</h4>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>24/7 security monitoring</li>
                    <li>Automated threat detection</li>
                    <li>Incident response team</li>
                    <li>Regular backup dan disaster recovery</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Batasan Tanggung Jawab</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium mb-2">Layanan "As Is":</h3>
                  <p className="text-sm text-gray-600 mb-3">
                    Layanan disediakan "sebagaimana adanya" tanpa jaminan tersurat atau tersirat.
                  </p>
                </div>
                
                <div className="bg-white p-4 rounded border">
                  <h4 className="font-medium mb-2">Batasan Ganti Rugi:</h4>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Maksimal sebesar nilai pembelian</li>
                    <li>Tidak termasuk kerugian tidak langsung</li>
                    <li>Tidak berlaku untuk kelalaian berat</li>
                    <li>Tunduk pada hukum yang berlaku</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Penangguhan dan Penghentian</h2>
            <div className="bg-yellow-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">Kondisi Penangguhan Akun:</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded">
                  <h4 className="font-medium mb-2">⏸️ Penangguhan Sementara:</h4>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Aktivitas mencurigakan</li>
                    <li>Multiple failed login attempts</li>
                    <li>Laporan penyalahgunaan</li>
                    <li>Investigasi keamanan</li>
                  </ul>
                </div>
                <div className="bg-white p-4 rounded">
                  <h4 className="font-medium mb-2">🚫 Penghentian Permanen:</h4>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Pelanggaran berulang</li>
                    <li>Aktivitas ilegal</li>
                    <li>Fraud atau penipuan</li>
                    <li>Ancaman keamanan</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Hukum yang Berlaku</h2>
            <div className="bg-indigo-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">Yurisdiksi:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Syarat ini diatur oleh hukum Republik Indonesia</li>
                <li>Sengketa diselesaikan melalui Pengadilan Jakarta Selatan</li>
                <li>Mediasi diutamakan sebelum litigasi</li>
                <li>Bahasa Indonesia sebagai bahasa resmi</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Perubahan Syarat</h2>
            <div className="bg-green-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium mb-3">Pemberitahuan Perubahan:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Notifikasi email 30 hari sebelum perubahan</li>
                <li>Banner pemberitahuan di website</li>
                <li>Update tanggal "Terakhir diperbarui"</li>
                <li>Hak untuk menolak dan menutup akun</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Kontak</h2>
            <div className="bg-gray-100 p-6 rounded-lg">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="text-lg font-medium mb-3">📞 Informasi Kontak</h3>
                  <div className="space-y-2 text-sm">
                    <p><strong>Email:</strong> support@hilaltechnologic.info</p>
                    <p><strong>Legal:</strong> legal@hilaltechnologic.info</p>
                    <p><strong>Security:</strong> security@hilaltechnologic.info</p>
                    <p><strong>Response Time:</strong> 1-3 hari kerja</p>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-medium mb-3">🏢 Informasi Perusahaan</h3>
                  <div className="space-y-2 text-sm">
                    <p><strong>Nama:</strong> Hilal Technologic</p>
                    <p><strong>Alamat:</strong> Indonesia</p>
                    <p><strong>Website:</strong> hilaltechnologic.info</p>
                    <p><strong>Platform:</strong> shop.hilaltechnologic.info</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="mt-12 p-6 bg-gradient-to-r from-blue-50 to-green-50 rounded-lg border">
            <h3 className="text-lg font-medium mb-3">✅ Kesepakatan</h3>
            <p className="text-gray-700 mb-4">
              Dengan menggunakan layanan kami, Anda menyatakan bahwa Anda telah membaca, 
              memahami, dan menyetujui semua syarat dan ketentuan yang tercantum di atas.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Legally Binding</span>
              <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">Enforceable</span>
              <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm">Updated Regularly</span>
            </div>
          </div>
      </div>
    </div>
  )
}

export default TermsPage
